var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfilePicturesIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_211_1514)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.48214 9.82143V8.03571C8.48214 5.80357 10.2679 4.01786 12.5 4.01786C14.7321 4.01786 16.5179 5.80357 16.5179 8.03571V9.82143C16.5179 12.0536 14.7321 13.8393 12.5 13.8393C10.2679 13.8393 8.48214 12.0536 8.48214 9.82143ZM16.5179 14.7321H8.48214C6.74107 14.7321 5.35714 16.1161 5.35714 17.8571C5.35714 19.5982 6.74107 20.9821 8.48214 20.9821H16.5179C18.2589 20.9821 19.6429 19.5982 19.6429 17.8571C19.6429 16.1161 18.2589 14.7321 16.5179 14.7321ZM1.78571 2.67857C1.78571 2.1875 2.1875 1.78571 2.67857 1.78571H8.92857V0H2.67857C1.20536 0 0 1.20536 0 2.67857V8.92857H1.78571V2.67857ZM25 2.67857C25 1.20536 23.7946 0 22.3214 0H16.0714V1.78571H22.3214C22.8125 1.78571 23.2143 2.1875 23.2143 2.67857V8.92857H25V2.67857ZM8.92857 23.2143H2.67857C2.1875 23.2143 1.78571 22.8125 1.78571 22.3214V16.0714H0V22.3214C0 23.7946 1.20536 25 2.67857 25H8.92857V23.2143ZM25 22.3214V16.0714H23.2143V22.3214C23.2143 22.8125 22.8125 23.2143 22.3214 23.2143H16.0714V25H22.3214C23.7946 25 25 23.7946 25 22.3214Z",
    fill: "#605BFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_211_1514"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfilePicturesIcon);
export default __webpack_public_path__ + "static/media/ProfilePicturesIcon.ef38c2dd98ca0cbf5716d7c0d4d6b7a8.svg";
export { ForwardRef as ReactComponent };